import { deleteSearchParams, setSearchParamValue } from 'lib/url/searchUrlUtils'

type RoomFilterType = 'bedrooms' | 'beds' | 'bathrooms'

const roomFilterParamMap: Record<RoomFilterType, { gte: string, eq: string }> = {
  bedrooms: { gte: 'bedroomsGte', eq: 'bedroomsEq' },
  beds: { gte: 'bedsGte', eq: 'bedsEq' },
  bathrooms: { gte: 'bathroomsGte', eq: 'bathroomsEq' },
}

export function updateRoomFilterSearch(search: string, filterType: RoomFilterType, value: number) {
  const params = roomFilterParamMap[filterType]

  if (value === 0) {
    return deleteSearchParams(search, params.gte, params.eq)
  }

  const nextSearch = setSearchParamValue(search, params.gte, value)
  return deleteSearchParams(nextSearch, params.eq)
}
